import Menu from './Compartido/Menu.jsx';
import TextosCookies from './Cookies/TextosCookies.jsx';
import Footer from './Compartido/Footer.jsx';

const Cookies = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
            />
            <TextosCookies
                cookies={props.textocookies}
                ruta={props.ruta}
            />
            <Footer
                datos={props.websgrupo}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
            />
        </main>
    );
}

export default Cookies;
